import { ABNORMAL_STATE, ABNORMAL_STATE_TITLE } from '@app/constants/abnormalState'
import { TAG_TYPE } from '@app/constants/tag'

import { isNull, isNullable } from '@app/utils'

import type { LntTagType } from '@app/components/base/Tag/types'
import type { AbnormalState } from '@app/types'

export const matchAbnormalStatusTagType = (status: AbnormalState | null): LntTagType => {
  switch (status) {
    case ABNORMAL_STATE.CHECKED:
      return TAG_TYPE.success

    case ABNORMAL_STATE.ABNORMAL:
      return TAG_TYPE.warning

    default:
      return TAG_TYPE.default
  }
}

export const abnormalStatusTagText = (status: AbnormalState | null): string => {
  if (isNull(status) || isNullable(ABNORMAL_STATE_TITLE[status])) return 'Не определен'

  return ABNORMAL_STATE_TITLE[status]
}
